import React, { useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { Fragment } from 'react';
import Tablereact from '../common/tabulator/tablereact'
import Button from 'react-bootstrap-button-loader';
import { toast } from 'react-toastify'; 
import Loader from '../common/loaderapp';

const CategoriasBlog = () => {

    const [page, setPage] = useState(-1);
    const [look, setLook] = useState(false);
    const [datos, setDatos] = useState([]);
    const [nombre, setNombre] = useState('');
    const [load, setLoad] = useState(false);

    useEffect(() => {
        fetch('/p_categoria_publicacion', { method: 'GET', headers: {'Content-Type': 'application/json'} })
        .then(res => res.json())
        .then(res => {setDatos(res); setLoad(true)})
        .catch(err => {console.log('Error: '+err);setLook(false)})
    }, [look]);

    const cabecera = [
        { Header: <b>Id</b>, accessor: 'ID', style: { textAlign: 'center'}, width:'100px', editable:true , show:false},
        { Header: <b>Nombre</b>, accessor: 'NOMBRE', style: { textAlign: 'center'}, width:'Auto', editable:true , show:true},
    ];

    const agregar=()=>setPage(0)

    const actualizar=(dato)=>{
        setPage(dato.ID)
        setNombre(dato.NOMBRE)
    }

    const eliminar=(dato)=>{
        fetch('/p_categoria_publicacion', { method: 'DELETE', body: JSON.stringify({ID:dato.ID}), headers: {'Content-Type': 'application/json'} })
        .then(res => res.json())
        .then(res => setDatos(res))
        .catch(err => {console.log('Error: '+err);setLook(false)})
    }

    const insetar_actualizar=()=>{
        if(nombre.trim().length!=''){
            setLook(true)
            fetch('/p_categoria_publicacion', { method: page == 0 ? 'POST':'PUT', body: JSON.stringify({ID:page,nombre}), headers: {'Content-Type': 'application/json'} })
            .then(res => {setLook(false); setPage(-1); setNombre('')})
            .catch(err => {console.log('Error: '+err);setLook(false)})
        }
        else
            toast.warn(`Asigna un nombre.`,{ position: toast.POSITION.BOTTOM_RIGHT });
    }
    
    return (
        <Fragment>
            <Breadcrumb parent="Publicaciones" title="Categorías" />
            <div className="container-fluid">
                <div className="col-sm-12">
                    <div className="card">
                        {
                            load ==true?
                                (page == -1) ?
                                <Fragment>
                                    <div className="card-body datatable-react">
                                        <Tablereact
                                            myData={datos}
                                            cabecera={cabecera}
                                            pageSize={10}
                                            paginacion={true}
                                            buscador='Buscar'
                                            boton={{text:'Agregar Categoría',function:agregar}}
                                            eliminar_actualizar={{actualizar:actualizar,eliminar:eliminar}}
                                        />
                                    </div>
                                </Fragment>
                                :
                                <Fragment>
                                    <div className="card-header" style={{padding:'15px'}}>
                                        <button className="btn btn-outline-light-2x txt-dark" onClick={()=>{setPage(-1); setNombre('')}} disabled={look}>
                                            <i className="icofont icofont-arrow-left"/>Regresar
                                        </button>
                                    </div>
                                    <h4 className="mt-3 ml-4"><strong>{page==0 ? 'Agregar Categoría':'Actualizar Categoría'}</strong></h4>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label className={`form-label`}>Nombre de la Categoría</label>
                                                    <input name={`nombre`} value={nombre} onChange={(e)=>setNombre(e.target.value)} className={`form-control`} type="text" autoComplete="off"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            <div className="text-right">
                                                <Button className='btn-lg mr-4' onClick={insetar_actualizar} loading={look}>Guardar</Button>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            : <Loader/>
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default CategoriasBlog;